import { ReactNode } from 'react';
import { useUserHasRole } from '../../hooks/useUserHasRole';
export const AnonymousOnly: React.FC<{
	children: ReactNode;
}> = ({ children }) => {
	const anonymous = useUserHasRole('anonymous');
	return <>{anonymous && <>{children}</>}</>;
};
